module.exports = __webpack_public_path__ + "static/media/hombre.47305402.png";